var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4907 4.62442C12.3019 4.72434 12.0507 4.98009 11.9517 5.17351C11.8472 5.37884 11.8472 5.62084 11.9536 5.83259C12.0095 5.94534 12.6603 6.62184 14.0738 8.03901L16.1134 10.0832H9.80489C3.03072 10.0832 3.31122 10.0758 3.04539 10.2656C2.84189 10.4104 2.76855 10.6038 2.76855 10.9998C2.76855 11.3033 2.78047 11.3693 2.86022 11.5113C2.96105 11.6919 3.12972 11.823 3.3323 11.8789C3.41939 11.9037 5.66614 11.9165 9.7893 11.9165H16.1134L14.0738 13.9607C12.6603 15.3778 12.0095 16.0543 11.9536 16.1671C11.7913 16.4907 11.8729 16.8243 12.191 17.1424C12.5091 17.4605 12.8427 17.5421 13.1663 17.3798C13.28 17.323 14.1581 16.4733 16.0978 14.5437C17.6213 13.0284 18.9138 11.757 18.9716 11.7185C19.1127 11.625 19.2951 11.2189 19.2951 10.9998C19.2951 10.7652 19.1136 10.3774 18.9532 10.2674C18.8845 10.2207 17.5911 8.94926 16.0786 7.44134C14.2333 5.60251 13.2781 4.67484 13.1746 4.62351C12.9729 4.52267 12.6823 4.52359 12.4907 4.62442Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.svg";
export { ForwardRef as ReactComponent };